import {getLocationById} from "@/http/services/http-services-route";
import {WKT} from "ol/format";
import {getLayerByName, removeLayer} from "@/helpers/ol/ol-layer-helper";
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import {Icon, Style} from "ol/style";
import {Point} from "ol/geom";
import {Feature} from "ol";

const format = new WKT();
import marker from '../../../assets/img/marker.png'

import {getLatLonProjectionName, getViewProjectionName, isBelgium} from "@/helpers/ol/ol-projection-helper";
import {transform} from "ol/proj";
import {displayFeatureInfo} from "@/modules/ol/service/ol-service-wms";
import {clickMap} from "@/helpers/ol/ol-map-helper";
import {getDefaultZoom} from "@/helpers/ol/ol-zoom-helper";

export function goToLocationByAddressID(addressID) {

    getLocationById(addressID).then((data) => {

        const location = data.response.docs[0]

        let feature
        if(isBelgium()) {
            feature = format.readFeature(location.centroide_be);
        } else {
            feature = format.readFeature(location.centroide_ll, {
                dataProjection: getLatLonProjectionName(),
                featureProjection: getViewProjectionName(),
            });
        }

        const coordinate = feature.getGeometry().flatCoordinates
        addLocationMarker(coordinate)

        window.map.getView().animate({
            center: coordinate,
            duration: 2000,
            zoom: getDefaultZoom(),
        });

        // Click in map
        if(window.settings.MapSettingsDirectClick) {
            const checkAnimating = setInterval(() => {
                if(!window.map.getView().getAnimating()) {
                    setTimeout(() => {
                        const pixel = window.map.getPixelFromCoordinate(coordinate);
                        clickMap(pixel, feature.getGeometry().flatCoordinates);

                        clearInterval(checkAnimating)
                    }, 300)
                }
            }, 1000)
        }
    })
}

export function removeNotificationMarker() {
    removeLayer('notificationGeometry', false)
}

export function addLocationMarker(coordinate) {

    removeLayer('notificationGeometry', false)

    //// console.log(coordinate)
    const iconFeature = new Feature({
        geometry: new Point(coordinate),
    });

    const iconStyle = new Style({
        image: new Icon({
            anchor: [0.5, 46],
            anchorXUnits: 'fraction',
            anchorYUnits: 'pixels',
            src: marker,
        }),
    });

    iconFeature.setStyle(iconStyle);

    const layer = new VectorLayer({
        altitudeMode: 'clampToGround',
        name: 'notificationGeometry',
        zIndex: 10001,
        source: new VectorSource({
            features: [iconFeature],
        })
    })

    window.map.addLayer(layer);
}

export function getRouteLocation() {
    const layer = getLayerByName('notificationGeometry', false)
    if(layer) {
        return layer.getSource().getFeatures()[0]
    }
    return undefined
}
